import { jsx as _jsx } from "react/jsx-runtime";
import { Callout } from '@criteria-labs/react';
export function ErrorView({ error }) {
    return (_jsx(Callout, { color: "red", children: _jsx("pre", { className: "overflow-x-scroll text-xs text-zinc-700 dark:text-white/70", children: _jsx("code", { children: error.message }) }) }));
}
